import type { FunctionComponent } from 'react'

import { GamPanel } from '../../../../shared'
import { usePageGamConfig } from '../../../../shared/hooks/usePageGamConfig'
import type { PageInfo } from '../../../../shared/types'
import { useCtaRecommendationCtaService } from '../../../home/hooks/useCtaRecommendation'
import styles from './ArticlePageRhsGam.module.scss'

type Props = { pageInfo: PageInfo }

export const ArticlePageRhsGam: FunctionComponent<Props> = ({ pageInfo }) => {
  const gamConfig = usePageGamConfig({ pageInfo })
  const { ctaId, loading } = useCtaRecommendationCtaService()

  if (gamConfig === undefined) {
    return null
  }

  if (loading) {
    return null
  }

  return (
    <div className={styles.rhsGam}>
      <GamPanel
        {...gamConfig}
        ctaId={ctaId}
        gamId="div-gpt-ad-6221233-4"
        panelName="articleRHS"
        slotSize={[300, 250]}
        sizeMappings={[[[1270, 0], [[300, 250]]]]}
      />
    </div>
  )
}
